export const GET_USER_INITIAL_INFO = `query GetUserInitialInfo {
    me {
        id
        email
        roles {
            id
            type
            metadata
            merchant {
                id
                name
                logo
                logoBgColor
            }
        }
    }
    waffle {
        flags {
            name
            isActive
        }
    }
}`;
